module.exports = __webpack_public_path__ + "assets/media/level6-user-icon.7fd6b73e.png";